module.exports = __webpack_public_path__ + "static/img/icon-finished.74ce3cae.png";